module.exports = {
      id: "time-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#time",
      toString: function () {
        return this.url;
      }
    }